import { Field } from "formik";
import { Form, useForm } from "formik-redux";
import { useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import useTranslate from "../hooks/use-translate.hook";
import { DELETE_SCHEDULE_EVENT } from "./schedule.constants";
import { deleteEvent } from "./schedule.actions";
import { RadioButtons } from "../ui";

const ScheduleEventDelete = ({ open, onClose, event }) => {
    const dispatch = useDispatch();
    const t = useTranslate();

    const formik = useForm({
        form: DELETE_SCHEDULE_EVENT,
        enableReinitialize: true,
        initialValues: {
            id: event.id,
            type: event.type,
            recurrent: event.recurrent,
            startDate: event.startDate,
            mode: "SINGLE",
        },
        onSubmit: values => dispatch( deleteEvent( values ) ),
    });

    return (
        <Dialog open={ open }>
            <DialogTitle>{ t( "common:exclude" ) }</DialogTitle>
            <DialogContent>
                <Form formik={ formik }>
                    {
                        event.recurrent ?
                            <Field
                                name="mode"
                                label={ t( "common:mode" ) }
                                row={ false }
                                options={
                                    [
                                        {
                                            value: "SINGLE",
                                            label: t( "schedule:form-event.recurrent.update.single" ),
                                        }, {
                                            value: "FUTURE",
                                            label: t( "schedule:form-event.recurrent.update.future" ),
                                        }, {
                                            value: "ALL",
                                            label: t( "schedule:form-event.recurrent.update.all" ),
                                        }
                                    ]
                                }
                                component={ RadioButtons }
                            /> :
                            <DialogContentText>{ t( "schedule:event.delete.confirm" ) }</DialogContentText>
                    }
                </Form>
            </DialogContent>
            <DialogActions>
                <Button color="primary" onClick={ onClose } disabled={ formik.submitting }>
                    { t( "common:no" ) }
                </Button>
                <Button color="primary" onClick={ formik.submitForm } disabled={ formik.submitting }>
                    { t( "common:yes" ) }
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ScheduleEventDelete;